export default "__VITE_ASSET__DvROPX_S__"